module.exports = __webpack_public_path__ + "img/vignette-accessoires.909cbdf9.jpg";